export default "__VITE_ASSET__DMyFWw$B__"